/**
 * header -> disableLang
 */
export function disableLanguage() {
  document.querySelector('ewc-page-header')?.querySelector('ewc-button[mode=menu]')?.setAttribute('disabled', '');
}
